import { render, staticRenderFns } from "./details-threads.vue?vue&type=template&id=5fb6f9ba&"
import script from "./details-threads.vue?vue&type=script&lang=js&"
export * from "./details-threads.vue?vue&type=script&lang=js&"
import style0 from "./details-threads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports